<template>
  <el-dialog
    title="损失明细"
    :visible="visible"
    width="560px"
    append-to-body
    @close="close"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="医疗损失"
        ><el-input-number
          v-model="form.medical_losses"
          :min="0"
          :precision="2"
          :controls="false"
        /><span class="unit">元</span></el-form-item
      >
      <el-form-item label="误工损失"
        ><el-input-number
          v-model="form.work_losses"
          :min="0"
          :precision="2"
          :controls="false"
        /><span class="unit">元</span></el-form-item
      >
      <el-form-item label="伤残等级"
        ><el-select v-model="form.disability_level"
          ><el-option
            v-for="(label, index) in levels"
            :key="index"
            :label="label"
            :value="index"/></el-select
      ></el-form-item>
      <el-form-item label="伤残损失"
        ><el-input-number
          v-model="form.disability_losses"
          :min="0"
          :precision="2"
          :controls="false"
        /><span class="unit">元</span></el-form-item
      >
      <el-form-item label="死亡损失"
        ><el-input-number
          v-model="form.died_losses"
          :min="0"
          :precision="2"
          :controls="false"
        /><span class="unit">元</span></el-form-item
      >
      <el-form-item label="损失合计"
        ><el-input-number
          :value="total"
          :precision="2"
          :controls="false"
          disabled
        /><span class="unit">元</span></el-form-item
      >
    </el-form>
    <span slot="footer"
      ><el-button @click="close">取消</el-button
      ><el-button type="primary" :loading="saving" @click="save"
        >保存</el-button
      ></span
    >
  </el-dialog>
</template>

<script>
import { getClaimInfo, saveEmployerLosses } from "@/api/claims-management";
import { DISABILITY_LEVELS, fromCents, toCents } from "../constants";

export default {
  name: "EmployeeLossDialog",
  props: { visible: Boolean, orderId: [String, Number] },
  data() {
    return {
      saving: false,
      levels: DISABILITY_LEVELS,
      form: {
        medical_losses: 0,
        work_losses: 0,
        disability_level: 0,
        disability_losses: 0,
        died_losses: 0
      },
      rules: {}
    };
  },
  computed: {
    total() {
      return (
        Number(this.form.medical_losses || 0) +
        Number(this.form.work_losses || 0) +
        Number(this.form.disability_losses || 0) +
        Number(this.form.died_losses || 0)
      );
    }
  },
  watch: {
    visible(value) {
      if (value) this.load();
    }
  },
  methods: {
    async load() {
      const res = await getClaimInfo("ygx", { id: Number(this.orderId) });
      const data = res.data || {};
      this.form = {
        medical_losses: Number(fromCents(data.medical_losses) || 0),
        work_losses: Number(fromCents(data.work_losses) || 0),
        disability_level: Number(data.disability_level || 0),
        disability_losses: Number(fromCents(data.disability_losses) || 0),
        died_losses: Number(fromCents(data.died_losses) || 0)
      };
    },
    async save() {
      this.saving = true;
      try {
        await saveEmployerLosses({
          id: Number(this.orderId),
          medical_losses: toCents(this.form.medical_losses),
          work_losses: toCents(this.form.work_losses),
          disability_level: Number(this.form.disability_level),
          disability_losses: toCents(this.form.disability_losses),
          died_losses: toCents(this.form.died_losses),
          total_losses: toCents(this.total)
        });
        this.$message.success("保存成功");
        this.$emit("changed");
        this.close();
      } finally {
        this.saving = false;
      }
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
.unit {
  margin-left: 8px;
  color: #909399;
}
</style>
